import { render } from "./tableOrder.vue?vue&type=template&id=6a56c8d4&scoped=true"
import script from "./tableOrder.vue?vue&type=script&lang=js"
export * from "./tableOrder.vue?vue&type=script&lang=js"

import "./tableOrder.vue?vue&type=style&index=0&id=6a56c8d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56c8d4"]])

export default __exports__